// extracted by mini-css-extract-plugin
export default {"address":"vKULRNi0riodSgKe_sB5","subTitle":"CT2RRTb3bhPAAf_DutLa","mainContent":"ZyRT2Du7SwYAOIMoILc2","pulse":"bi_eYPeLC0KUw2AgrAqj"};